import { render } from "./Default.vue?vue&type=template&id=454c2a32"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"

import "./Default.vue?vue&type=style&index=0&id=454c2a32&lang=scss"
script.render = render

export default script